import React, { useMemo, useState } from 'react'
import { DndContext } from '@dnd-kit/core'
import { SortableContext, useSortable, arrayMove } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import { Collapse } from 'react-bootstrap'
import { client } from '../../utils'
import { customizeContent as endpoints } from '../../api_urls'
import SaveBar from './SaveBar'
import { toast, Toaster } from '@CommonComponents/toast'


function SortableChapter({ id, title }) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
  } = useSortable({ id })

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  }

  return (
    <div
      ref={setNodeRef}
      style={style}
      {...attributes}
      {...listeners}
      className="container-md p-3 m-3 w-90 rounded bg-white pointer shadow border-dotted"
    >
      <div className="d-flex flex-row justify-content-start ml-3">
        <h3 className="black d-flex align-items-middle">
          <span
            className="icon icon_menu9 mr-3 fs-xl"
            style={{ color: 'var(--nontext)' }}
          />
          <span>{title}</span>
        </h3>
      </div>
    </div>
  )
}


export default function ContentManager({ chapters: initialChapters}) {
  const [chapters, setChapters] = useState(initialChapters)
  const [saving, setSaving] = useState(false)
  const [comparison, setComparison] = useState(initialChapters)

  // Used by dnd-kit — array of stable IDs
  const chapterIds = useMemo(
    () => chapters.map(ch => ch[1]),
    [chapters]
  )

  const collapsed = chapters !== comparison

  const handleDragEnd = ({ active, over }) => {
    if (!over || active.id === over.id) return

    setChapters(prev => {
      const oldIndex = prev.findIndex(ch => ch[1] === active.id)
      const newIndex = prev.findIndex(ch => ch[1] === over.id)
      return arrayMove(prev, oldIndex, newIndex)
    })
  }

  const handleSave = async () => {
    setSaving(true)

    const chapIds = chapters.map(ch => ch[1])
    const url = endpoints.save()

    try {
      const response = await client.post(url, chapIds)
      if (response.status === 200) {
        setComparison(chapters)
        toast.success('Chapters reordered successfully!')
      } else {
        console.error(response.error, response.status)
        toast.error(response.error)
      }
    } catch (err) {
      console.error(`Error posting ${url}`, err)
      toast.error(`Error posting ${url}`, err)
    } finally {
      setSaving(false)
    }
  }

  return (
    <div>
      <Toaster />
      <DndContext onDragEnd={handleDragEnd} >
        <SortableContext items={chapterIds} >
          <div className="ContentManager text-left">
            {chapters.map(chapter => (
              <SortableChapter
                key={chapter[1]}
                id={chapter[1]}
                title={chapter[0]}
              />
            ))}
          </div>
        </SortableContext>
      </DndContext>
      <Collapse in={collapsed}>
        <div
          className={
            collapsed
              ? 'fixed-bottom text-white bg-dark-transparent p-3 d-flex flex-row justify-content-end'
              : ''
          }
        >
          <span className="p-3">
            Saving changes will immediately reorder the content for all users.
          </span>
          <SaveBar saving={saving} handleSave={handleSave} />
        </div>
      </Collapse>
    </div>
  )
}
